import { List, Datagrid, TextField, DateField, NumberField } from "react-admin"

const AreaTypeList = () => (
  <List perPage={25}>
    <Datagrid rowClick="show">
      <TextField source="id" />
      <TextField source="key" />
      <TextField source="name" />
      <NumberField source="areas_count" />
    </Datagrid>
  </List>
)

export default AreaTypeList
